import React, { useState } from 'react';
import RecoverableImage from '../../features/images/RecoverableImage';

// Build60 source priority: custom, four distinct previews, first preview, P.
// Preserve the existing web-only preview fallback while a failed custom cover recovers.
function ArtworkSession({ custom, previews }) {
  const [failed, setFailed] = useState(false);
  const images = previews.length >= 4 ? previews : previews.slice(0, 1);
  const fallback = images.length ? (
    images.map((url) => <RecoverableImage key={url} src={url} alt="" loading="lazy" />)
  ) : (
    <span aria-hidden="true">P</span>
  );
  return (
    <div
      className={`pp-artwork pp-playlist-artwork ${(!custom || failed) && images.length === 4 ? 'pp-mosaic' : ''}`}
    >
      {custom ? (
        <RecoverableImage
          src={custom}
          alt=""
          loading="lazy"
          onFailureChange={setFailed}
          fallback={fallback}
        />
      ) : (
        fallback
      )}
    </div>
  );
}
export default function PlaylistArtwork({ playlist }) {
  const custom = playlist.imageUrl?.trim();
  const previews = [...new Set((playlist.previewImageUrls || []).filter(Boolean))].slice(0, 4);
  return <ArtworkSession key={custom || ''} custom={custom} previews={previews} />;
}
